<mat-form-field appearance="outline" bmTheme="find-tracks-select">
  <mat-label>{{ lg.sortTrackBy.rating.label }}</mat-label>
  <mat-select [(value)]="currentSortById" (selectionChange)="sortTracks($event)">
    @if (isFreeBeatsPage) {
      <mat-option [value]="FreeBeatsSortBy.AddedDateDesc">
        {{ lg.sortTrackBy.rating.freeBeatsOptions.addedDateDesc }}
      </mat-option>
      <mat-option [value]="FreeBeatsSortBy.AddedDateAsc">
        {{ lg.sortTrackBy.rating.freeBeatsOptions.addedDateAsc }}
      </mat-option>
      <mat-option [value]="FreeBeatsSortBy.DownloadsDesc">
        {{ lg.sortTrackBy.rating.freeBeatsOptions.downloadsDesc }}
      </mat-option>
      <mat-option [value]="FreeBeatsSortBy.DownloadsAsc">
        {{ lg.sortTrackBy.rating.freeBeatsOptions.downloadsAsc }}
      </mat-option>
    } @else {
      @if (isBeatmakerPage) {
        <mat-option [value]="BeatsSortBy.OrderNumber">
          {{ lg.sortTrackBy.rating.options.default }}
        </mat-option>
      }
      <mat-option [value]="BeatsSortBy.Date">
        {{ lg.sortTrackBy.rating.options.newest }}
      </mat-option>
      <mat-option [value]="BeatsSortBy.ChartTop">
        {{ lg.sortTrackBy.rating.options.top }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
